import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-program',
    templateUrl: './program.component.html',
    styleUrls: ['./program.component.scss'],
    standalone: false
})
export class ProgramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
